<template>
	<div class="row">
    <user-box v-for="user in data" :userid="user" :key="user"></user-box>
  </div>
</template>

<script>
import UserBox from '@/components/UserBox'

export default {
  props: ['data'],
  components: {
    UserBox
  }
}
</script>



// WEBPACK FOOTER //
// UserRow.vue?088180d5